import React, { useState, useEffect } from "react";
import Chart from 'react-apexcharts';
import { TYPE_COUNT } from '../../common/URLs';

import { getLocalStorageItem } from "../../common/localStorageUtils";
import apiClient from "../../axios";

function ApexChart() {

  const [typeCount, setTypeCount] = useState();
  useEffect(() => {
    getTypeCountInChart();

  }, []);
  function getTypeCountInChart() {

    apiClient
      .post(TYPE_COUNT,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setTypeCount(response.data);
      })
      .catch(function (error) {
      });

  }
  const sTypeCount = typeCount?.stakeHolderTypeCounts;


  return (<div id="chart" style={{ left: 0 }}>
    <Chart
      type="pie"
      width={350}
      height={400}
      style={{ align : "center" }}
      series={[sTypeCount?.[0]?.count ? sTypeCount?.[0]?.count : 0, sTypeCount?.[1]?.count ? sTypeCount?.[1]?.count : 0, sTypeCount?.[2]?.count ? sTypeCount?.[2]?.count : 0, sTypeCount?.[3]?.count ? sTypeCount?.[3]?.count : 0, sTypeCount?.[4]?.count ? sTypeCount?.[4]?.count : 0]}
      options={
        {
          labels: [sTypeCount?.[0]?.stakeHolderType ? sTypeCount?.[0]?.stakeHolderType : "",
          sTypeCount?.[1]?.stakeHolderType ? sTypeCount?.[1]?.stakeHolderType : "",
          sTypeCount?.[2]?.stakeHolderType ? sTypeCount?.[2]?.stakeHolderType : "",
          sTypeCount?.[3]?.stakeHolderType ? sTypeCount?.[3]?.stakeHolderType : "",
          sTypeCount?.[4]?.stakeHolderType ? sTypeCount?.[4]?.stakeHolderType : ""],
          legend: {
              width: 150,
            height:350,
           floating: false,
            position: "right",
            fontSize: "11vw",
            markers: {
              width: 10,
              height: 10,
              shape: "square",
              radius: 2
            }
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            onDatasetHover: {
              highlightDataSeries: true
            }
          },
          stroke: {
            show: false

          }
        }}>
    </Chart>
  </div>
  )
}
export default ApexChart;